export default "__VITE_ASSET__BJDdv9yV__"